<template>
  <div>
    <el-upload :action="dataObj.host"
               :data="dataObj"
               list-type="picture"
               accept="image/*"
               :multiple="false"
               :show-file-list="showFileList"
               :file-list="fileList"
               :before-upload="beforeUpload"
               :on-remove="handleRemove"
               :on-success="handleUploadSuccess"
               :on-preview="handlePreview">
      <el-button size="small"
                 type="primary"
                 style="float: right;">上传图片</el-button>
      <!--<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过10MB</div>-->
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%"
           :src="fileList[0].url">
    </el-dialog>
  </div>
</template>
<script>
import { policy } from '@/api/oss'
import md5 from 'js-md5'

export default {
  name: 'singleUpload',
  props: {
    value: String,
    showList: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    imageUrl () {
      return this.value;
    },
    imageName () {
      if (this.value != null && this.value !== '') {
        return this.value.substr(this.value.lastIndexOf("/") + 1);
      } else {
        return null;
      }
    },
    fileList () {
      return [{
        name: this.imageName,
        url: this.imageUrl
      }]
    },
    showFileList: {
      get: function () {
        return this.value !== null && this.value !== '' && this.value !== undefined && this.showList;
      },
      set: function (newValue) {
      }
    }
  },
  data () {
    return {
      dataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: 'https://haihaigo.oss-cn-shenzhen.aliyuncs.com'
      },
      dialogVisible: false
    };
  },
  methods: {
    emitInput (val) {
      this.$emit('input', val)
    },
    handleRemove (file, fileList) {
      this.emitInput('')
    },
    handlePreview (file) {
      this.dialogVisible = true
    },
    beforeUpload (file) {
      let _self = this
      // 最大只能上传2M文件
      if (file.size > 2097152) {
        this.$message.error('上传失败，最大只能上传2M大小的图片')
        return false
      }
      return new Promise((resolve, reject) => {
        policy().then(response => {
          _self.dataObj.policy = response.data.policy
          _self.dataObj.signature = response.data.signature
          _self.dataObj.ossaccessKeyId = response.data.accessKeyId
          _self.dataObj.key = response.data.dir + '/' + file.uid + md5(file.name)
          _self.dataObj.dir = response.data.dir
          _self.dataObj.host = response.data.host
          resolve(true)
        }).catch(err => {
          console.log(err)
          reject(false)
        })
      })
    },
    handleUploadSuccess (res, file) {
      this.showFileList = this.showList
      this.fileList.pop()
      this.fileList.push({
        name: file.uid + md5(file.name),
        url: this.dataObj.host + '/' + this.dataObj.dir + '/' + file.uid + md5(file.name)
      })
      this.emitInput(this.fileList[0].url)
    }
  }
}
</script>
<style>
</style>





// WEBPACK FOOTER //
// src/components/Upload/singleUpload.vue